module.exports = __webpack_public_path__ + "4a35b76f18607c9040a53c859bf05758.png";